import { useCallback } from 'react'
import useTracking, { TrackingFnType } from '@hooks/useTracking'
import { stripHtml } from '@hooks/useTracking/utils'

const useGallerySlideChangeTracking = (
  activeIndex: number,
  galleryId?: string,
  galleryTitle?: string
) => {
  const trackingOnSlideChange = useCallback<TrackingFnType>(
    () => ({
      event: 'slideshow_slide_change',
      eventCategory: 'slideshow',
      eventLabel: galleryId
        ? `${galleryId}:${stripHtml(galleryTitle)}`
        : 'auto-generated-gallery',
      eventAction: 'slide_change',
      slideNumber: activeIndex + 1,
      id: galleryId,
    }),
    [galleryId, galleryTitle, activeIndex]
  )

  return useTracking(trackingOnSlideChange)
}

const useGallerySlideClickTracking = (
  activeIndex: number,
  galleryId?: string,
  galleryTitle?: string
) => {
  const trackingOnClick = useCallback<TrackingFnType>(
    () => ({
      event: 'slideshow_fullscreen',
      eventCategory: 'slideshow',
      eventLabel: galleryId
        ? `${galleryId}:${stripHtml(galleryTitle)}`
        : 'auto-generated-gallery',
      eventAction: 'fullscreen',
      slideNumber: activeIndex,
      id: galleryId,
    }),
    [galleryId, galleryTitle, activeIndex]
  )

  return useTracking(trackingOnClick)
}

export { useGallerySlideChangeTracking, useGallerySlideClickTracking }
